export const PlanTypes = { BASIC: 0, INHERITANCE: 1, FLEXIBLE: 2 };

export const SocialMedia = { TWITTER: 'https://twitter.com/cryptoretirementplan' };

export const Contacts = {
  CHRISTIAN: 'christiangperez@gmail.com',
  LUCAS: 'lucas.alejandro.perez@gmail.com'
};
